mutation AssociateMasterTemplateWithCampaign($masterTemplateId: ID!, $campaignId: ID!) {
    associateMasterTemplateWithCampaign(masterTemplateId: $masterTemplateId, campaignId: $campaignId) {
        _id
        name
        adType
        height
        width
        preview
        created
        modified
    }
}
